import { useEffect, useState } from 'react';

import { modules } from 'subjects/common/CurrentUserService';

const useAccessibleModules = () => {
    const [userModules, setUserModules] = useState<number[] | null>(null);

    useEffect(() => {
        const subscription = modules.subscribe((modulesIds: number[]) => {
            setUserModules(modulesIds || []);
        });

        return () => subscription.unsubscribe();
    }, []);

    return userModules;
};

export default useAccessibleModules;
